<template>
  <div id="page-resume-days">
    <div class="page-inner container">
      <div v-if="loaded" class="tour-data-container">
        <div class="tour-data">
          <h3 class="h5 mb-12">{{ $t("travelBook.tourResume") }}</h3>
          <div class="tour-resume-container">
            <div class="tour-resume-day">
              <div class="day-data" v-if="tourTemplate && shouldDisplayBeforeTripSection">
                <component
                  :is="isSummary ? 'div' : 'a'"
                  :href="isSummary ? '#' : `#accordion-tour-day-before-${tourTemplate?.beforeInformation?.id}`"
                  class="text-decoration-none p-16 p-lg-24 d-flex flex-column flex-md-row justify-content-md-between align-items-start align-items-md-center m-16"
                >
                  <div class="d-flex flex-column flex-md-row align-items-md-center pe-16 mb-12 mb-md-0">
                    {{ $t("clientTour.beforeTour") }}
                  </div>

                  <v-button v-if="!isSummary" class="w-fit text-nowrap px-16 py-8" size="xs" variant="primary">
                    {{ $t("clientTour.beforeTour") }}
                  </v-button>
                </component>
              </div>
            </div>
          </div>

          <div class="tour-resume-container">
            <div class="tour-resume-day">
              <div class="day-data" v-if="tourTemplate && shouldDisplayIncludeInfoSection">
                <component
                  :is="isSummary ? 'div' : 'a'"
                  :href="isSummary ? '#' : `#accordion-tour-day-include-${tourTemplate?.includedInformation?.id}`"
                  class="text-decoration-none p-16 p-lg-24 d-flex flex-column flex-md-row justify-content-md-between align-items-start align-items-md-center m-16"
                >
                  <div class="d-flex flex-column flex-md-row align-items-md-center pe-16 mb-12 mb-md-0">
                    {{ $t("clientTour.include") }}
                  </div>

                  <v-button v-if="!isSummary" class="w-fit text-nowrap px-16 py-8" size="xs" variant="primary">
                    {{ $t("clientTour.include") }}
                  </v-button>
                </component>
              </div>
            </div>
          </div>

          <div class="tour-resume-container">
            <div class="tour-resume-day">
              <div class="day-data" v-if="tourTemplate && shouldDisplayNotIncludeInfoSection">
                <component
                  :is="isSummary ? 'div' : 'a'"
                  :href="isSummary ? '#' : `#accordion-tour-day-not-include-${tourTemplate?.notIncludedInformation?.id}`"
                  class="text-decoration-none p-16 p-lg-24 d-flex flex-column flex-md-row justify-content-md-between align-items-start align-items-md-center m-16"
                >
                  <div class="d-flex flex-column flex-md-row align-items-md-center pe-16 mb-12 mb-md-0">
                    {{ $t("clientTour.notInclude") }}
                  </div>

                  <v-button v-if="!isSummary" class="w-fit text-nowrap px-16 py-8" size="xs" variant="primary">
                    {{ $t("clientTour.notInclude") }}
                  </v-button>
                </component>
              </div>
            </div>
          </div>

          <div class="tour-resume-container">
            <div class="tour-resume-day">
              <div class="day-data" v-if="tourTemplate && shouldDisplayOptionalInfoSection">
                <component
                  :is="isSummary ? 'div' : 'a'"
                  :href="isSummary ? '#' : `#accordion-tour-day-optional-${tourTemplate?.optionalInformation?.id}`"
                  class="text-decoration-none p-16 p-lg-24 d-flex flex-column flex-md-row justify-content-md-between align-items-start align-items-md-center m-16"
                >
                  <div class="d-flex flex-column flex-md-row align-items-md-center pe-16 mb-12 mb-md-0">
                    {{ $t("clientTour.optional") }}
                  </div>

                  <v-button v-if="!isSummary" class="w-fit text-nowrap px-16 py-8" size="xs" variant="primary">
                    {{ $t("clientTour.optional") }}
                  </v-button>
                </component>
              </div>
            </div>
          </div>

          <div class="tour-resume-container">
            <div v-for="tourDay in tourDays" :key="tourDay.id" class="tour-resume-day">
              <div class="day-data">
                <component
                  :is="isSummary ? 'div' : 'a'"
                  :href="isSummary ? '#' : `#accordion-tour-day-${tourDay.id}`"
                  class="text-decoration-none p-16 p-lg-24 d-flex flex-column flex-md-row justify-content-md-between align-items-start align-items-md-center m-16"
                >
                  <div class="d-flex flex-column flex-md-row align-items-md-center pe-md-16 mb-12 mb-md-0 overflow-hidden w-100">
                    <div
                      v-if="tourDay.type === 'stage'"
                      class="locations d-flex flex-column flex-md-row align-items-start align-items-md-center text-sm mb-4 mb-lg-0 overflow-hidden"
                    >
                      <div class="d-flex align-items-center mb-4 mb-md-0">
                        <v-icon icon="run" size="xl" space="me-12" />
                        <div v-if="!!tourDay.originId && !!tourDay.origin" class="text-truncate">{{ tourDay.origin.name }}</div>
                        <div v-else class="text-truncate">{{ $t("traveler.withoutOrigin") }}</div>
                      </div>

                      <div class="d-flex align-items-center ms-32 ms-md-0">
                        <v-icon icon="arrow-right" size="sm" class="d-none d-md-block px-8" />
                        <v-icon icon="arrow-down" size="sm" class="d-md-none pe-8" />
                        <div v-if="!!tourDay.destinationId && !!tourDay.destination" class="text-truncate">{{ tourDay.destination.name }}</div>
                        <div v-else class="text-truncate">{{ $t("traveler.withoutDestination") }}</div>
                      </div>
                    </div>

                    <div v-else class="locations flex-shrink-1 d-flex align-items-center text-sm mb-4 mb-lg-0 overflow-hidden">
                      <v-icon icon="run" size="xl" space="me-12" />

                      <div v-if="!!tourDay.originId && !!tourDay.origin" class="text-truncate">{{ tourDay.origin.name }}</div>
                      <div v-else class="text-truncate">{{ $t("traveler.withoutLocation") }}</div>
                    </div>

                    <span class="dot-divider mx-20 d-none d-md-flex" />

                    <div class="d-flex align-items-center flex-nowrap text-nowrap ms-32 ms-md-0">
                      <div class="date text-gray-500 mb-0">
                        {{ $str.formatDateTime(tourDay.date, "dd MMMM yyyy") }}
                      </div>

                      <template v-if="tourDay.type === 'stage' && !!tourDay.stageLength">
                        <span class="dot-divider mx-20" />

                        <div class="stage-length text-gray-500">
                          {{ tourDay.stageLength }} {{ $t("general.shared.kilometersShorted") }}
                        </div>
                      </template>
                    </div>
                  </div>

                  <v-button v-if="!isSummary" class="w-fit text-nowrap px-16 py-8" size="xs" variant="primary">
                    {{ $t("general.button.seeDay") }}
                  </v-button>
                </component>
                <template v-if="!!tourDay.items && tourDay.items.length > 0 && isSummary">
                  <div class="row pt-4 pb-24 ps-16 ps-md-24 pe-16 pe-md-48">
                    <div
                      v-for="dayItem in mapTourDayItems(tourDay.items, tourDay.date, tourDay.disabledItemResources)"
                      :key="`tour-resume-${dayItem.type}`"
                      class="information-container-summary col-12 col-sm-6 col-lg-4 col-xl-3 px-12 py-12 mb-16 mb-md-0"
                    >
                      <div class="d-flex align-items-center">
                        <v-icon :icon="findConceptByKey('supplier.type', dayItem.type).icon" size="xl" space="me-12" />
                        <h4 class="text-normal mb-0">{{ getDayItemType(dayItem.type) }}</h4>
                      </div>
                      <div
                        v-for="(item, index) in mapResources(dayItem.items)"
                        :key="index"
                        class="fw-semi text-sm ps-16 ps-md-36 py-4"
                      >
                        <template
                          v-if="
                            item.resourceName !== undefined && item.resourceName !== null && item.resourceName !== ''
                          "
                        >
                          <span v-if="showSuuplier">
                            {{ item.supplierName }}
                          </span>
                          <p :title="`${item.resourceName} x${item.count}`" class="resource-name mb-0">
                            {{ `${item.resourceName} x${item.count}` }}
                          </p>
                        </template>
                      </div>

                      <template v-if="!!tourDay.optionalItemResources && tourDay.optionalItemResources.length > 0">
                        <div
                          v-for="(item, index) in mapOptResources(tourDay.optionalItemResources, dayItem.type)"
                          :key="index"
                          class="information-container-summary d-flex align-items-center fw-semi text-sm text-gray-500 ps-16 ps-md-36 py-4"
                        >
                          <span v-if="showSuuplier">
                            {{ item.supplierName }}
                          </span>
                          <p :title="`${item.resourceName} x${item.count}`" class="resource-name mb-0">
                            {{ `${item.resourceName} x${item.count}` }}
                          </p>
                        </div>
                      </template>
                    </div>
                  </div>
                </template>

                <template
                  v-if="
                    (!tourDay.items || tourDay.items.length === 0) &&
                    !!tourDay.disabledItemResources &&
                    tourDay.disabledItemResources.length > 0 &&
                    isSummary
                  "
                >
                  <div class="d-flex flex-column flex-wrap py-4 ps-24 pe-16">
                    <div class="px-12 py-8 px-xxl-16 py-lg-12">
                      <div class="d-flex align-items-center">
                        <v-icon :icon="findConceptByKey('supplier.type', 'hotel').icon" size="xl" space="me-12" />
                        <h4 class="text-normal mb-0">{{ getDayItemType("hotel") }}</h4>
                      </div>

                      <div
                        v-for="(item, index) in mapOptResources(tourDay.disabledItemResources)"
                        :key="index"
                        class="information-container-summary d-flex align-items-center fw-semi text-sm ps-16 ps-md-36 py-4"
                      >
                        <span v-if="showSuuplier">
                          {{ item.supplierName }}
                        </span>
                        <p :title="`${item.resourceName} x${item.count}`" class="resource-name mb-0">
                          {{ `${item.resourceName} x${item.count}` }}
                        </p>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <div class="tour-resume-container">
            <div class="tour-resume-day">
              <div class="day-data" v-if="tourTemplate && shouldDisplayAfterTripSection">
                <component
                  :is="isSummary ? 'div' : 'a'"
                  :href="isSummary ? '#' : `#accordion-tour-day-after-${tourTemplate?.afterInformation?.id}`"
                  class="text-decoration-none p-16 p-lg-24 d-flex justify-content-between m-16"
                >
                  <div class="d-flex flex-column flex-md-row align-items-md-center pe-16">
                    {{ $t("clientTour.afterTour") }}
                  </div>

                  <v-button v-if="!isSummary" class="w-fit text-nowrap px-16 py-8" size="xs" variant="primary">
                    {{ $t("clientTour.afterTour") }}
                  </v-button>
                </component>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="!isSummary"
          class="map-container break-avoid d-flex align-items-center justify-content-center hide-print"
        >
          <v-map ref="travelBookHotelsMapContainer" :items="markers" :locations="markers" :zoom="5" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { findConceptByKey } from "@/helpers/ConceptHelper";
import VMap from "@/components/vendor/VMap.vue";
import Supplier from "@/api/objects/Supplier";
import VIcon from "@/components/vendor/basic/icon/VIcon.vue";
import TourDay from "@/api/objects/TourDay";
import VButton from "@/components/vendor/basic/button/VButton.vue";
import ClientTour from "@/api/objects/ClientTour";
import { DateTime } from "luxon";
import TourDayItem from "@/api/objects/TourDayItem";

export type ResourceType = {
  id: string | number;
  name: string;
  currentDay: string;
  type: string;
  disabled: boolean;
};

export type MappedItemType = {
  type: string;
  items: ResourceType[];
};

export default defineComponent({
  name: "TheTravelBookResumeDays",
  components: {
    VMap,
    VIcon,
    VButton,
  },
  props: {
    tourDays: {
      type: Array as PropType<TourDay[]>,
      required: false,
    },
    isSummary: {
      type: Boolean,
      required: false,
      default: false,
    },
    clientTour: {
      type: Object as PropType<ClientTour>,
      required: false,
    },
    tourTemplate: {
      type: [] as any,
      required: true,
    },
    showSuuplier: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      findConceptByKey,
    };
  },
  computed: {
    markers(): any[] {
      const uniqueLocations = new Map();

      this.tourDays?.forEach((day: TourDay) => {
        if (day.origin && day.origin.lat && day.origin.lng) {
          uniqueLocations.set(day.origin.id, day.origin);
        }

        if (day.type === "stage" && day.destination && day.destination.lat && day.destination.lng) {
          uniqueLocations.set(day.destination.id, day.destination);
        }
      });

      return Array.from(uniqueLocations.values());
    },
    shouldDisplayBeforeTripSection() {
      const translations = this.tourTemplate?.beforeInformation?.translations || [];
      return translations.some((translation: { description: null; }) => translation.description !== null);
    },
    shouldDisplayIncludeInfoSection() {
      const translations = this.tourTemplate?.includedInformation?.translations || [];
      return translations.some((translation: { description: null; }) => translation.description !== null);
    },
    shouldDisplayNotIncludeInfoSection() {
      const translations = this.tourTemplate?.notIncludedInformation?.translations || [];
      return translations.some((translation: { description: null; }) => translation.description !== null);
    },
    shouldDisplayOptionalInfoSection() {
      const translations = this.tourTemplate?.optionalInformation?.translations || [];
      return translations.some((translation: { description: null; }) => translation.description !== null);
    },
    shouldDisplayAfterTripSection() {
      const translations = this.tourTemplate?.afterInformation?.translations || [];
      return translations.some((translation: { description: null; }) => translation.description !== null);
    },
  },
  data() {
    return {
      suppliers: [] as Supplier[],
      loaded: false,
    };
  },
  async created() {
    this.loaded = true;
  },
  methods: {
    isLogged() {
      const islogged = localStorage.getItem("agency");
      return islogged !== null && islogged !== "";
    },
    getDayItemType(type: string): string {
      if (type === "hotel") {
        return this.$t("travelBook.accommodation");
      }

      return findConceptByKey("supplier.type", type).name;
    },
    /**
     * Counts the occurrences of each resource name within an array of resources.
     * This is for determining how many resources of each type are present.
     *
     * @param {TourDayItemResource[]} resources - The array of resources to count.
     * @returns {Record<string, number>} An object mapping each resource name to its count of occurrences.
     */
    mapResources(resources: any[]): Record<string, number> {
      const counts: Record<string, number> = {};

      resources.forEach((resource) => {
        const name = resource.name;
        const supplierName = resource.supplierName;

        const key = `${name}-${supplierName}`;

        if (!counts[key]) {
          counts[key] = {
            resourceName: name,
            supplierName: supplierName,
            count: 0,
          };
        }

        counts[key].count++;
      });

      return Object.values(counts);
    },
    mapOptResources(resources: any[], type?: string): Record<string, any> {
      let resourcesByType = resources;

      if (type) {
        resourcesByType = resources.filter((resource) => resource.type === type);
      }

      const counts: Record<string, any> = {};

      resourcesByType.forEach((resource) => {
        const name = resource.name;
        const supplierName = resource.supplierName;

        const key = `${name}-${supplierName}`;

        if (!counts[key]) {
          counts[key] = {
            resourceName: name,
            supplierName: supplierName,
            count: 0,
          };
        }

        counts[key].count++;
      });

      return Object.values(counts);
    },
    mapTourDayItems(
      tourDayItems: TourDayItem[],
      tourDayDate: string,
      tourDayItemsDisabled?: ResourceType[]
    ): MappedItemType[] {
      const itemsGroupByType = tourDayItems.group((item: TourDayItem) => item.type);

      return Object.keys(itemsGroupByType).map((type: string) => {
        const tourDayItems = itemsGroupByType[type];

        let items: ResourceType[] = [];

        tourDayItems.forEach((tourDayItem: TourDayItem) => {
          const resourcesMapped: ResourceType[] = tourDayItem.resources.map((resource) => ({
            id: resource.id,
            name: resource.resource.name,
            currentDay: DateTime.fromISO(tourDayDate).toFormat("yyyy-MM-dd"),
            type: resource.resource.type,
            supplierName: tourDayItem?.supplierName,
            disabled: false,
          }));

          const resourcesMappedAux =
            tourDayItemsDisabled && tourDayItemsDisabled.length > 0
              ? resourcesMapped.concat(tourDayItemsDisabled)
              : resourcesMapped;

          items = items.concat(resourcesMappedAux);
        });

        return {
          type,
          items,
        };
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.hide-print {
  @media print {
    display: none;
  }
}

.break-avoid {
  break-inside: avoid;
}

.information-container-summary {
  position: relative;
  border-bottom: 1px solid var(--uq-gray-300);

  @media (min-width: 768px) {
    border-bottom: none;
    border-right: 1px solid var(--uq-gray-300);
  }

  &:last-child {
    border-bottom: none;
    border-right: none;
  }
}

.tour-data-container {
  .tour-data {
    .tour-resume-day {
      break-inside: avoid;
      margin-bottom: 1.75rem;

      .day-data {
        position: relative;
        background-color: var(--uq-white);
        border-radius: 0.5rem;
        box-shadow: 0 1px 0.25rem var(--uq-gray-300);

        .locations {
          @media print {
            font-size: 0.875rem;
          }
        }

        .date,
        .stage-length {
          font-size: 0.875rem;

          @media print {
            font-size: 0.75rem;
          }
        }
      }
    }
  }

  .resource-name {
    @media only screen {
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  .map-container {
    @media only screen {
      height: 31rem;
    }

    :deep(.map) {
      border-radius: 0.5rem;
    }

    @media print {
      width: 0 !important;
      height: 25rem;

      :deep(.map) {
        width: 0 !important;
      }
    }
  }
}
</style>
